import "./styles.scss";
import React, { useState } from "react";
const FilePicker = ({
    label,
    star,
    onFileChange,
    errorMessage
}) => {
    const [fileName, setFileName] = useState("");

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileName(file.name);
            onFileChange(file);
        } else {
            setFileName("");
            onFileChange(null);
        }
    };

    return <div>
        <label className="label-file" htmlFor="file-input">
            {label} <span style={{ color: "var(--accent-colors-red)" }}>{star}</span>
        </label>
        <div className="file-chooser-container"
            style={{
                border: errorMessage ? "1px solid  var(--accent-colors-red)" : ""
            }}>
            <input
                type="file"
                id="file-input"
                className="file-input"
                onChange={handleFileChange}
                 />
            <label htmlFor="file-input" className="file-label">
                {fileName ? fileName : "Choose a file"}
            </label>
            {errorMessage && <p className="errorMessage">{errorMessage}</p>}{" "}
        </div>
    </div>;
};
export default FilePicker;